import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BackButtonComponent } from '../../shared/components/back-button/back-button.component';
import { CardContentComponent } from '../../shared/components/card/card-content.component';
import { CardHeaderComponent } from '../../shared/components/card/card-header.component';
import { CardTitleComponent } from '../../shared/components/card/card-title.component';
import { CardComponent } from '../../shared/components/card/card.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';
import { LogControlsComponent } from '../settings/log-controls/log-controls.component';

@Component({
  selector: 'app-logging',
  standalone: true,
  imports: [
    BackButtonComponent,
    CardComponent,
    CardHeaderComponent,
    CardTitleComponent,
    CardContentComponent,
    LogControlsComponent,
    TranslatePipe,
  ],
  templateUrl: './logging.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './logging.component.css',
})
export class LoggingComponent {}
